import { Typography } from '@euler/app/components/typography';
import { Icon } from '@euler/components/Icomoon';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CommonTaskStatus } from '@euler/model/enum';
import { memo } from 'react';
import { View } from 'react-native';
import { useTheme } from 'styled-components';

export const TaskCardTitle = memo(
  ({
    text,
    status,
    shared,
    viewed,
  }: {
    text: string;
    status: CommonTaskStatus;
    shared?: boolean;
    viewed?: boolean;
  }) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    const successColor = theme.colors.status.success;
    const color =
      status === CommonTaskStatus.Pending
        ? theme.colors.status.warn
        : status === CommonTaskStatus.InProgress
        ? theme.colors.status.danger
        : theme.colors.status.success;
    return (
      <HStack
        css={`
          justify-content: flex-start;
        `}
      >
        <Typography.Label
          medium
          size={rpx(18)}
          lineHeight={rpx(20)}
          color={theme.components.card.titleColor}
          css={`
            top: ${rpx(2)}px;
          `}
        >
          {text}
        </Typography.Label>
        {status === CommonTaskStatus.Pending ? null : (
          <View
            css={`
              padding: 0px ${rpx(6)}px;
              height: ${rpx(20)}px;
              border-radius: ${rpx(10)}px;
              border-width: 1px;
              margin-left: ${rpx(8)}px;
              border-color: ${color};
              align-items: center;
              justify-content: center;
              margin-right: ${rpx(3)}px;
            `}
          >
            <Typography.Label
              size={rpx(12)}
              light
              color={color}
              lineHeight={rpx(18)}
            >
              {status === CommonTaskStatus.InProgress
                ? '待完成并推送报告'
                : '已推送报告'}
            </Typography.Label>
          </View>
        )}
        {shared ? (
          <View
            css={`
              height: ${rpx(20)}px;
              margin-left: ${rpx(5)}px;
              align-items: center;
              justify-content: flex-start;
              flex-direction: row;
            `}
          >
            <Icon name="share" color={successColor} size={rpx(8)} />
            <Typography.Label
              size={rpx(10)}
              light
              color={successColor}
              lineHeight={rpx(18)}
              css={`
                margin-left: ${2}px;
              `}
            >
              已分享
            </Typography.Label>
          </View>
        ) : null}
        {viewed ? (
          <View
            css={`
              height: ${rpx(20)}px;
              margin-left: ${rpx(5)}px;
              align-items: center;
              justify-content: flex-start;
              flex-direction: row;
            `}
          >
            <Icon name="check" color={successColor} size={rpx(10)} />
            <Typography.Label
              size={rpx(10)}
              light
              color={successColor}
              lineHeight={rpx(18)}
              css={`
                margin-left: ${2}px;
              `}
            >
              已查看
            </Typography.Label>
          </View>
        ) : null}
      </HStack>
    );
  },
);
